module.exports = {
      id: "default-image-usage",
      viewBox: "0 0 322 191",
      url: __webpack_public_path__ + "svg-sprite-5579a9c22c9b0e56875750544888299d.svg#default-image",
      toString: function () {
        return this.url;
      }
    }